import { useTranslation } from 'react-i18next';
import { InquiryForm } from '../components/InquiryForm';
import { Seo } from '../components/Seo';
import { company } from '../data/company';

export function Contact() {
  const { t } = useTranslation();

  return (
    <>
      <Seo
        title="Contact Us | GyroNavi"
        description="Get in touch with GyroNavi's engineering team for product inquiries, pricing, and technical consultation on inertial navigation sensors."
        path="/contact"
      />
      <section className="section grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <h1 className="text-4xl font-black text-ink">{t('common:contact.title')}</h1>
          <p className="mt-3 text-slate-600">{t('common:contact.subtitle')}</p>
          <div className="mt-8 space-y-4 rounded-lg bg-white p-6 shadow-sm">
            <div>
              <p className="text-sm font-semibold text-slate-500">{t('common:contact.phone')}</p>
              <a className="font-semibold text-signal" href={`tel:${company.phone}`}>
                {company.phoneDisplay}
              </a>
            </div>
            <div>
              <p className="text-sm font-semibold text-slate-500">{t('common:contact.whatsapp')}</p>
              <a className="font-semibold text-signal" href={company.whatsappUrl} target="_blank" rel="noopener noreferrer">
                {company.whatsapp}
              </a>
            </div>
            <div>
              <p className="text-sm font-semibold text-slate-500">{t('common:contact.email')}</p>
              <a className="font-semibold text-signal" href={`mailto:${company.email}`}>
                {company.email}
              </a>
            </div>
            <div>
              <p className="text-sm font-semibold text-slate-500">{t('common:contact.location')}</p>
              <p className="font-semibold text-ink">{company.location}</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-slate-500">{t('common:contact.hours')}</p>
              <p className="font-semibold text-ink">{company.hours}</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-slate-500">{t('common:contact.responseTime')}</p>
              <p className="font-semibold text-ink">{t('common:contact.responseValue')}</p>
            </div>
          </div>
        </div>
        <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
          <h2 className="text-2xl font-black text-ink">{t('common:contact.quickInquiry')}</h2>
          <div className="mt-6">
            <InquiryForm source="contact_page" />
          </div>
        </div>
      </section>
    </>
  );
}
